// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16935908","453":"8bf73e7a","667":"f3c29af7"}[chunkId] + ".chunk.js";
};